<template>
  <div class="flex h-full w-full items-stretch">
    <div class="flex h-full w-44 flex-col">
      <div class="bg-static-info-max rounded-tl-lg h-12 w-full"></div>
      <div class="bg-static-info-max ml-12 grow"></div>
    </div>
    <div class="-mx-1 flex w-8 flex-col text-[#e3f77e]">
      <svg
        class="w-full"
        fill="none"
        height="4"
        viewBox="0 0 8 4"
        width="8"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8 4H0V0H1C1 1.65685 2.34315 3 4 3C5.60489 2.99974 6.91581 1.7393 6.99609 0.154297L7 0H8V4Z"
          fill="currentColor"
        />
      </svg>

      <span class="bg-static-info-max -mt-1 grow" />
    </div>
    <div class="flex h-full grow flex-col">
      <div class="bg-static-info-max rounded-tr-lg h-12 w-full"></div>
      <div class="bg-static-info-max mr-12 grow"></div>
    </div>
  </div>
</template>
